<template>
  <span class="i" :class="[size, icon, iconName, state, align]" ></span>
</template>

<script>
export default {
  props: {
    size: { type: String, default: 'small' },
    icon: { type: String },
    uicon: { type: String },
    state: { type: String, default: 'deactive' },
    align: { type: String }
  },
  computed: {
    iconName: function () {
      if (this.uicon !== '' && this.uicon !== undefined) {
        return 'i_ico-' + this.uicon
      } else {
        return ''
      }
    }
  },
  name: 'icon'
}
</script>

<style scoped>
.xxxsmall {
  display: block;
  position: relative;
  min-width: 10px;
  width: 10px;
  height: 10px;
  background-repeat: round;
  font-size: 10px;
}
.xxsmall {
  display: block;
  position: relative;
  min-width: 12px;
  width: 12px;
  height: 12px;
  background-repeat: round;
  font-size: 12px;
}
.xsmall {
  display: block;
  position: relative;
  min-width: 18px;
  width: 18px;
  height: 18px;
  background-repeat: round;
  font-size: 18px;
}
.small {
  display: block;
  position: relative;
  min-width: 26px;
  width: 26px;
  height: 26px;
  background-repeat: round;
  font-size: 26px;
}
.small + span {
  display: block;
}
.profile {
  display: block;
  position: relative;
  min-width: 30px;
  width: 30px;
  height: 30px;
  background-repeat: round;
  font-size: 30px;
}
.medium {
  display: block;
  position: relative;
  min-width: 35px;
  width: 35px;
  height: 35px;
  background-repeat: round;
  font-size: 35px;
}
.large {
  display: block;
  position: relative;
  min-width: 50px;
  width: 50px;
  height: 50px;
  background-repeat: round;
  font-size: 50px;
}
.xlarge {
  display: block;
  position: relative;
  min-width: 60px;
  width: 60px;
  height: 60px;
  background-repeat: round;
  font-size: 60px;
}
.xxlarge {
  display: block;
  position: relative;
  min-width: 80px;
  width: 80px;
  height: 80px;
  background-repeat: round;
  font-size: 80px;
}
.ularge {
  display: block;
  position: relative;
  min-width: 200px;
  width: 200px;
  height: 200px;
  background-repeat: round;
  font-size: 200px;
}
.u_icon {
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Icon.vue